<template>
  <section v-if="showActionSection" class="detail-data-wrapper mt-2 mb-0">
    <h6 v-if="!hideActionTitle" class="form-title">AKSI</h6>

    <DisbursementPendingStatementAction
      v-if="showPendingBranchAction"
      :disbursementPending="disbursementPending"
      :canAction="isBranchRole"
      :refreshDetail="refreshDetail"
    />

    <DisbursementPendingRefundAction
      v-else-if="transaction.status === PENDING_STATUS.PROCESS_REFUND"
      :disbursementPending="disbursementPending"
      :isBranchRole="isBranchRole"
      :isFinanceRole="isFinanceRole"
      :refreshDetail="refreshDetail"
    />

    <DisbursementPendingShortfallTransferAction
      v-else-if="showShortfallTransferAction"
      :disbursementPending="disbursementPending"
      :refreshDetail="refreshDetail"
    />
  </section>
</template>

<script>
import DisbursementPendingRefundAction from './DisbursementPendingRefundAction'
import DisbursementPendingShortfallTransferAction from './DisbursementPendingShortfallTransferAction'
import DisbursementPendingStatementAction from './DisbursementPendingStatementAction'
import { PENDING_STATUS, parseDocumentUrls } from './disbursementPendingUtils'

export default {
  name: 'DisbursementPendingActionSection',
  components: {
    DisbursementPendingRefundAction,
    DisbursementPendingShortfallTransferAction,
    DisbursementPendingStatementAction,
  },
  props: {
    disbursementPending: {
      type: Object,
      default: () => ({}),
    },
    transaction: {
      type: Object,
      required: true,
    },
    refreshDetail: {
      type: Function,
      required: true,
    },
  },
  computed: {
    PENDING_STATUS() {
      return PENDING_STATUS
    },
    IS_HAVE_PERMISSION_CABANG() {
      return this.$helper.hasPermissionMenuChildren('KPD')
    },
    IS_HAVE_PERMISSION_FINANCE() {
      return this.$helper.hasPermissionMenuChildren('KPF')
    },
    isBranchRole() {
      return this.IS_HAVE_PERMISSION_CABANG
    },
    isFinanceRole() {
      return this.IS_HAVE_PERMISSION_FINANCE
    },
    refundDocuments() {
      return parseDocumentUrls(this.disbursementPending.pathFotoRefund)
    },
    hasRefundDocuments() {
      return this.refundDocuments.length > 0
    },
    showActionSection() {
      if (this.transaction.status === this.PENDING_STATUS.PENDING && !this.showPendingBranchAction) {
        return false
      }

      if (this.transaction.status === this.PENDING_STATUS.PROCESS_SHORTFALL && !this.showShortfallTransferAction) {
        return false
      }

      return this.transaction.status !== this.PENDING_STATUS.COMPLETED
        && this.transaction.status !== this.PENDING_STATUS.WAITING_BANK_RESPONSE
    },
    showPendingBranchAction() {
      return this.transaction.status === this.PENDING_STATUS.PENDING && this.isBranchRole
    },
    showShortfallTransferAction() {
      return this.transaction.status === this.PENDING_STATUS.PROCESS_SHORTFALL && this.isFinanceRole
    },
    showRefundFinanceWaitingAlert() {
      return this.isFinanceRole && !this.hasRefundDocuments
    },
    showRefundBranchWaitingAlert() {
      return this.isBranchRole && this.hasRefundDocuments
    },
    hideActionTitle() {
      return this.transaction.status === this.PENDING_STATUS.WAITING_BANK_RESPONSE
        || this.transaction.status === this.PENDING_STATUS.PROCESS_SHORTFALL
        || this.transaction.status === this.PENDING_STATUS.PROCESS_REFUND
        || this.showRefundFinanceWaitingAlert
        || this.showRefundBranchWaitingAlert
    },
  },
}
</script>

<style scoped>
.form-title {
  color: #20a8d8;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 16px;
}
</style>
